// Map API license modules names to module keys, so they can be translated.

import { NavKeys } from '@common-modules/dependencies/navigation/nav-keys.enum';
import { CtNavKeys } from './navigation/ct-nav-keys';
export class CloudTwinLicenseModule {
  apiName: string;
  navKey?: NavKeys; // Used to infer translation.
}

// Maps the names of the module licences in the back with the nav keys, which hold translation names.
export const cloudTwinLicenseModules: CloudTwinLicenseModule[] = [
  {
    apiName: 'Workspaces',
    navKey: CtNavKeys.Workspaces,
  },
  {
    apiName: 'ModelVersions',
    navKey: CtNavKeys.ModelVersions,
  },
  {
    apiName: 'Measurements',
    navKey: CtNavKeys.Measurements,
  },
  {
    apiName: 'Map',
    navKey: CtNavKeys.Map,
  },
];
